interface Name {
    firstName?: string;
    middleName?: string;
    lastName?: string;
}

const getFullName = ({ firstName, middleName, lastName }: Name): string => {
    return [lastName, firstName, middleName].filter(Boolean).join(' ');
};

export const getNameWithInitials = ({ firstName, middleName, lastName }: Name): string => {
    const shortFirstName = firstName ? `${firstName[0]}.` : '';
    const shortMiddleName = middleName ? `${middleName[0]}.` : '';
    const initials = shortFirstName ? `${shortFirstName}${shortMiddleName}` : '';
    return lastName ? `${lastName} ${initials}` : '';
};

export default getFullName;
